import { usePeriod } from "../lib/PeriodContext";
import { Calendar, Filter } from "lucide-react";

const PERIOD_LABELS = {
  MTD: "Month to Date",
  QTD: "Quarter to Date",
  YTD: "Year to Date · FY",
  AS_ON: "As On",
};

/**
 * Prominent badge shown at the top of any page that uses the period selector.
 * Tells the user exactly which timeline + month + project scope they are viewing.
 */
export const PageTimeline = ({ fyLabel }) => {
  const { period, asOf, months, selectedProjects } = usePeriod();
  const monthLabel = months.find((m) => m.value === asOf)?.label;
  const periodLabel = PERIOD_LABELS[period] || period;
  const periodWithFy = period === "YTD" && fyLabel ? `${periodLabel} ${fyLabel.replace("FY ", "")}` : periodLabel;
  const projCount = selectedProjects?.length || 0;

  return (
    <div
      className="flex items-center flex-wrap gap-2 px-4 py-2.5 bg-white border border-slate-200 rounded-md"
      data-testid="page-timeline-badge"
    >
      <div className="flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-[0.18em] text-slate-500 font-mono">
          Viewing
        </span>
        <span
          className="text-xs font-semibold font-mono px-2 py-0.5 rounded"
          style={{ background: "#D4AF37", color: "#0F1D32" }}
          data-testid="page-timeline-period"
        >
          {period}
        </span>
        <span className="text-xs text-slate-700 font-medium">{periodWithFy}</span>
      </div>
      {monthLabel && (
        <>
          <span className="text-slate-300">·</span>
          <div className="flex items-center gap-1.5 text-xs text-slate-600">
            <Calendar size={11} />
            <span className="font-mono tabular-nums">{monthLabel}</span>
          </div>
        </>
      )}
      <span className="text-slate-300">·</span>
      <div className="flex items-center gap-1.5 text-xs text-slate-600">
        <Filter size={11} />
        <span>{projCount === 0 ? "All Projects" : `${projCount} project${projCount > 1 ? "s" : ""}`}</span>
      </div>
    </div>
  );
};
